// Делает доступным jQuery через window.
"use strict";

import $ from 'jquery';

window.jQuery = window.$ = $;

export default $;